import React, { Component } from "react";
import { connect } from "react-redux";
import {
  setMenuTopIndex,
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex
} from "../../../redux/actions/menuActions";
import Menu from "../../accounting/Menu"
import ExpenseReports from "../../../modules/presence/expenseReports/expenseReports";

class Home extends Component {
  componentDidMount() {
    this.props.setMenuTopIndex("expenseReports");
    this.props.setMenuLeftContent(Menu);
    this.props.setMenuLeftIndex("expenseReports");
    this.props.setMenuLeftItemIndex("");
  }

  render() {
    return (
      <ExpenseReports />
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    },
    setMenuLeftContent: index => {
      dispatch(setMenuLeftContent(index));
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    }
  };
};

export default connect(null, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// src/pages/presence/expenseReports/Home.js